import type { AbilityDisplayTrigger, CombatPosition } from '@hexcrawl/shared-utils';

export type AbilityDisplayEventPayload = {
  trigger: AbilityDisplayTrigger;
  abilityId: string;
  casterId: string;
  targetId?: string;
  casterPosition?: CombatPosition;
  targetPosition?: CombatPosition;
};

type AbilityDisplayEventHandler = (payload: AbilityDisplayEventPayload) => void;

const handlers = new Set<AbilityDisplayEventHandler>();

export const abilityDisplayEvents = {
  subscribe(handler: AbilityDisplayEventHandler) {
    handlers.add(handler);
    return () => handlers.delete(handler);
  },
  emit(payload: AbilityDisplayEventPayload) {
    handlers.forEach((handler) => handler(payload));
  },
};
